import { Language, languageToCode } from '@/types/language';
import { Sex, sexToCode } from '@/types/sex';
import { removeUndefinedValues } from '@/utils/iteration';
import moment from 'moment';

import { IBasicAddress } from './addresses';
import { envVars } from './envVars';

export const patientHost = envVars.patientHost;
export const backendHost = envVars.backendHost;
export const graphQlPath = `${envVars.backendHost}graphql/`;

// TODO: Move all functions that are creating URLs to this file. E.g. createBookingLink().

export const createPatientPortalBookingLink = ({
    patient,
    partnerId,
    address,
}: {
    patient: {
        id: string;
        firstName: string;
        lastName: string;
        email: string | null;
        phoneNumber: string | null;
        sex: Sex;
        dateOfBirth: Date;
        preferredLanguage: string;
    };
    partnerId: string;
    address: IBasicAddress | null;
}) => {
    // If there is no address (and thus no zipcode), we have to go to Patient's zipcode
    //  selection screen first.
    const path = address ? 'book' : 'location';
    // Since patient doesn't process phone numbers with country codes, remove the country code
    // if the phone number is defined.
    const phone = patient.phoneNumber?.slice(-10);

    const queryParams = new URLSearchParams({
        partner_id: partnerId,
        // The `removeUndefinedValues` removes any keys that were not defined on the `patient`.
        ...removeUndefinedValues({
            first_name: patient.firstName,
            last_name: patient.lastName,
            email: patient.email ?? '',
            phone: phone ?? '',
            sex: sexToCode(patient.sex),
            dob: moment(patient.dateOfBirth).format('YYYY-MM-DD'),
            preferredLanguage: languageToCode(patient.preferredLanguage as Language),
        }),
        ...(address && {
            address1: address.line1,
            address2: address.line2,
            city: address.city,
            state: address.state,
            zip_code: address.zipCode,
        }),
    });

    return patientHost + path + '?' + queryParams.toString();
};

export const createPatientPortalConfirmationLink = (visitId: string) => {
    return `${patientHost}confirmation/${visitId}`;
};
